import routerOptions0 from "/app/src/app/router.options.ts";
import routerOptions1 from "/app/node_modules/.pnpm/nuxt@3.3.3_@netlify+blobs@9.1.2_@types+node@18.19.123_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5__bsjyb4ct7qas5zu3ia5jgctso4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}